import { LandingTemplate } from "@/components/LandingTemplate";
import { IMG, FAQS } from "@/data/site";

const faqs = FAQS.filter((f) => f.c === "Long-Term Stay" || f.c === "Laundry");

export default function ExtendedStay() {
  return (
    <LandingTemplate
      seo={{
        title: "Extended Stay & Weekly Hotel in Ottawa, KS",
        description: "Weekly and monthly extended-stay lodging in Ottawa, Kansas at Super 8 by Wyndham. Ideal for construction crews, travel nurses, corporate housing, relocation and long-term stays near I-35 — with guest laundry, in-room fridge and microwave.",
        path: "/extended-stay",
        breadcrumbs: [{ name: "Home", path: "/" }, { name: "Extended Stay", path: "/extended-stay" }],
        faqs,
      }}
      kicker="Stay a While"
      heroTitle="Extended Stay"
      heroLines={["A home base", "for the long", "haul"]}
      heroImage={IMG.affordableRoom}
      intro="Working a project in the area, on a travel assignment, or between homes? Our comfortable rooms, guest laundry, in-room refrigerators and microwaves make weekly and monthly stays easy on you — and easy on the budget. Call us directly for extended-stay rates."
      audiences={["Weekly stays", "Monthly stays", "Construction workers", "Travel nurses", "Insurance housing", "Corporate housing", "Utility & pipeline crews", "Government employees", "Engineers & consultants", "Remote workers", "Relocation", "Temporary housing"]}
      features={[
        { icon: "WashingMachine", title: "On-Site Guest Laundry", desc: "Keep up with laundry without leaving the property." },
        { icon: "Refrigerator", title: "Fridge & Microwave", desc: "Most rooms include a mini-fridge and microwave for easy meals." },
        { icon: "Wifi", title: "Reliable Free WiFi", desc: "Work remotely and stream comfortably every night." },
        { icon: "Truck", title: "Crew & Vehicle Parking", desc: "Free parking for work trucks, vans and equipment." },
        { icon: "Coffee", title: "Free Daily Breakfast", desc: "Start every workday with a free hot-start breakfast." },
        { icon: "BadgeDollarSign", title: "Weekly & Monthly Rates", desc: "Call the hotel directly for the best long-stay pricing." },
      ]}
      bandImage={IMG.senior}
      bandTitle="Comfort that lasts"
      bandText="An extended stay should feel like more than a room. With daily housekeeping, a 24-hour front desk, free breakfast and parking that fits the whole crew, we make longer stays genuinely comfortable — night after night."
      benefits={[
        "Guest laundry on-site",
        "In-room refrigerator & microwave in most rooms",
        "Free breakfast & WiFi every day",
        "Free parking for crews and equipment",
        "24-hour front desk",
        "Weekly & monthly rates — call to book",
      ]}
      keywords={["Extended stay Ottawa KS", "Weekly hotel Ottawa Kansas", "Monthly hotel Ottawa KS", "Hotel for construction crews", "Travel nurse housing Kansas", "Corporate housing Ottawa KS", "Long stay hotel near I-35"]}
      faqs={faqs}
    />
  );
}
